const defaultLang = {
  hr: '{{count}} hr',
  hrPlural: '{{count}} hrs',
  min: '{{count}} min',
  minPlural: '{{count}} mins',
};

const translations = new Map([
  ['en', defaultLang],
  [
    'es',
    {
      hr: '{{count}} h',
      hrPlural: '{{count}} h',
      min: '{{count}} min',
      minPlural: '{{count}} min',
    },
  ],
  [
    'fr',
    {
      hr: '{{count}} h',
      hrPlural: '{{count}} h',
      min: '{{count}} min',
      minPlural: '{{count}} min',
    },
  ],
  [
    'de',
    {
      hr: '{{count}} Std.',
      hrPlural: '{{count}} Stdn.',
      min: '{{count}} Min.',
      minPlural: '{{count}} Min.',
    },
  ],
  [
    'nl',
    {
      hr: '{{count}} uur',
      hrPlural: '{{count}} uren',
      min: '{{count}} min',
      minPlural: '{{count}} min',
    },
  ],
  [
    'it',
    {
      hr: '{{count}} ora',
      hrPlural: '{{count}} ore',
      min: '{{count}} minuto',
      minPlural: '{{count}} minuti',
    },
  ],
  [
    'lt',
    {
      hr: '{{count}} val.',
      hrPlural: '{{count}} val.',
      min: '{{count}} min.',
      minPlural: '{{count}} min.',
    },
  ],
  [
    'el',
    {
      hr: '{{count}} ώρα',
      hrPlural: '{{count}} ώρες',
      min: '{{count}} λεπτό',
      minPlural: '{{count}} λεπτά',
    },
  ],
  [
    'pt',
    {
      hr: '{{count}} hr',
      hrPlural: '{{count}} hrs',
      min: '{{count}} min',
      minPlural: '{{count}} mins',
    },
  ],
]);

/* eslint-disable @typescript-eslint/naming-convention */
const localeMap = new Map([
  ['de_AT', 'de'],
  ['de_CH', 'de'],
  ['de_DE', 'de'],
  ['en_BE', 'en'],
  ['en_GB', 'en'],
  ['en_IE', 'en'],
  ['en_NL', 'en'],
  ['es_ES', 'es'],
  ['fr_BE', 'fr'],
  ['fr_FR', 'fr'],
  ['it_IT', 'it'],
  ['lt_LT', 'lt'],
  ['nl_BE', 'nl'],
  ['nl_NL', 'nl'],
  ['pt_PT', 'pt'],
  ['el_GR', 'el'],
  ['fr_CH', 'fr'],
  ['it_CH', 'it'],
]);
/* eslint-enable @typescript-eslint/naming-convention */

const getTranslationMap = (locale: string) => {
  const key = localeMap.get(locale) || 'en';
  return translations.get(key);
};

export const formatTime = (totalMinutes: number, locale = 'en_GB') => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const translation = getTranslationMap(locale) || defaultLang;

  const hourTemplate = hours === 1 ? translation.hr : translation.hrPlural;
  const hourLabel = hourTemplate.replace('{{count}}', String(hours));
  const minuteTemplate =
    minutes === 1 ? translation.min : translation.minPlural;
  const minuteLabel = minuteTemplate.replace('{{count}}', String(minutes));

  // do not show `0 h 12 min` but `12 min`
  // do not show `1 h 0 min` but `1 h`
  const duration = `${hours > 0 ? hourLabel : ''} ${
    minutes > 0 ? minuteLabel : ''
  }`.trim();

  return duration;
};
